<template>
  <theme />
</template>

<script>

import theme from './theme'
export default {
  components: {
    theme
  },
  data() {
    return {
    }
  },
  created() {
  }
}
</script>
